export const setCookie = (name, value) => {
    const date = new Date();
    date.setTime(date.getTime() + (2 * 24 * 60 * 60 * 1000)); // Two days cookie
    const expireData = date.toUTCString();

    document.cookie = `${name}=${value}; expires=${expireData}; path=/`;
};

export const expireCookie = (name) => {
    document.cookie = `${name}=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
};
